module.exports = __webpack_public_path__ + "ec466adb11ee17883fa98d7040bc1d6b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/screenshots/Restauranteurimgur.jpg
 ** module id = 207
 ** module chunks = 0
 **/